import { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../components/layouts/main-layout";
import { formatIndianNumber } from "../../components/helper-components/helper-function";
import DynamicTransactionTable from "../../components/tables/dynamic-transaction-table";
import SalesPurchaseFilter from "../../components/sales-section/sales-purchase-filter";
import BadgesComponent from "../../components/tables/badges-component";
import TransSummaryComp from "../../components/helper-components/trans-summary-comp";
import {
  ArrowDown,
  ArrowUp,
  Delete,
  DeleteIcon,
  IterationCcw,
  Play,
  SquarePen,
  Trash2,
} from "lucide-react";
import {
  alertDeleteAction,
  alertStatusAction,
  alertTableAction,
} from "../../redux/actions/alert-action";
import { update } from "lodash";
import { act } from "react";
import errorToast from "../../components/helper-components/error-toast";
import successToast from "../../components/helper-components/success-toast";
import TickMark from "../../assets/icons/tick-mark";
import { Tally2 } from "lucide-react";
import { Bell } from "lucide-react";
import AlertFilter from "../../components/alert-management/alert-filter";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";

const AlertTable = () => {
  const [heading, setHeading] = useState([]);
  const [alertSummary, setAlertSummary] = useState({});
  // const [heading, setHeading] = useState([]);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [reload, setReload] = useState(false);

  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "alert_name",
    from: "",
    to: "",
    inputValue: "",
    status: "",
    channel_values: [],
  });

  useEffect(() => {
    dispatch(
      alertTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setAlerts(data?.data?.notifications ?? []);
    setDataCount(data?.data?.pagination?.total_items ?? 0);
    setAlertSummary(data?.data?.stats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);

  function handleDelete(id) {
    if (!loading) {
      setLoading(true);
      dispatch(
        alertDeleteAction(
          {
            ntf_id: id,
          },
          (data) => {
            setReload(!reload);
            setLoading(false);
            successToast(data?.message);

            setAction(false);
          },
          (error) => {
            setLoading(false);
            errorToast(<p>{error?.data?.message}</p>);
          }
        )
      );
    }
  }

  function handleStatusChange(status, id) {
    const newStatus = status === "Active" ? "Paused" : "Active";
    dispatch(
      alertStatusAction(
        {
          ntf_id: id,
          start_or_stop: newStatus === "Paused" ? false : true,
        },
        (data) => {
          setReload(!reload);
          successToast(data?.message);
        },
        (error) => {
          errorToast(<p>{error?.data?.message}</p>);
        }
      )
    );
  }
  const tableBodyData = alerts?.map((item) => {
    return {
      id: item?.ntf_id,
      alert_name: item?.alert_name ?? "--",
      frequency: item?.frequency ?? "--",
      channels: (
        <div className="flex gap-2">
          {" "}
          {item?.is_email && (
            <span className="px-3 py-2 rounded-[4px] text-[var(--trans-stats-con-blue-fg)] bg-[var(--trans-stats-con-blue-bg)] flex items-center">
              Email
            </span>
          )}{" "}
          {item?.is_sms && (
            <span className="px-3 py-2 rounded-[4px] text-[var(--trans-stats-con-green-fg)] bg-[var(--trans-stats-con-green-bg)] flex items-center">
              SMS
            </span>
          )}{" "}
          {item?.is_whatsapp && (
            <span className="px-3 py-2 rounded-[4px] text-[var(--trans-stats-con-red-fg)] bg-[var(--trans-stats-con-red-bg)] flex items-center">
              WhatsApp
            </span>
          )}
        </div>
      ),
      condition_type: item?.condition_type ?? "--",
      last_run_date: item?.last_run_date
        ? moment().diff(moment(item.last_run_date), "days") < 1
          ? moment(item.last_run_date).fromNow() // "2 min ago", "an hour ago"
          : moment(item.last_run_date).calendar(null, {
              lastDay: "[Yesterday] h:mm A",
              sameDay: "[Today] h:mm A",
              lastWeek: "[Last] dddd h:mm A",
              sameElse: "MMM D, YYYY h:mm A",
            })
        : "--",
      status: <BadgesComponent status={item?.status} />,
      created_date: moment(item?.created_date).format("MMM D, YYYY"),
      created_by: item?.created_by ?? "--",
      updated_by: item?.updated_by ?? "--",
      updated_date: moment(item?.updated_date).format("MMM D, YYYY"),
      act: (
        <div className="flex gap-3">
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/edit-alert/${item?.ntf_id}`);
            }}
          >
            <SquarePen size={14} color="var(--primary)" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleStatusChange(item?.status, item?.ntf_id);
            }}
          >
            {item?.status === "Active" ? (
              <Tally2 size={18} color="var(--list-table-row-pause-color)" />
            ) : (
              <Play size={18} color="var(--success-color)" />
            )}
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(item?.ntf_id);
            }}
          >
            <Trash2 size={18} color="var(--error-color)" />
          </button>
        </div>
      ),
    };
  });

  const filterby = showFilter ? (
    <AlertFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setCurrentPage={setCurrentPage}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Active Alerts",
      value: alertSummary?.count ?? 0,
      icon: (
        <div className="rounded-full px-1 py-1 bg-[var(--trans-stats-con-green-fg)] text-nowrap">
          <TickMark width={11} height={11} fill="#ffffff" />
        </div>
      ),
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Paused",
      value: alertSummary?.pushed_count ?? 0,
      icon: <Tally2 size={16} color="var(--trans-stats-con-orange-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Triggered Today",
      value: alertSummary?.today_triggered_count ?? 0,
      icon: <Bell size={16} color="var(--trans-stats-con-blue-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "priority Levels",
      value: (
        <div className="flex gap-3">
          <span className="flex items-start gap-1">
            {alertSummary?.high_priority_count ?? 0}{" "}
            <ArrowUp size={12} color="var(--trans-stats-con-green-fg)" />
          </span>
          <span className="flex items-start gap-1">
            {alertSummary?.medium_priority_count ?? 0}

            <span className="h-2 w-2 bg-[var(--trans-stats-con-orange-fg)]"></span>
          </span>

          <span className="flex items-start gap-1 ">
            {alertSummary?.low_priority_count ?? 0}{" "}
            <ArrowDown size={12} color="var(--trans-stats-con-red-fg)" />
          </span>
        </div>
      ),

      icon: <IterationCcw size={16} color="var(--trans-stats-con-red-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const alertData = parsed.find((obj) => obj?.alert_management_list);
      if (alertData?.alert_management_list) {
        setHeading(alertData.alert_management_list);
      }
    }
  }, []);

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="alert_management"
      list={true}
      title="Settings"
    >
      <div className="flex justify-between pt-3 mx-6 text-sml">
                <div className=" pb-4 flex items-center gap-2">
                    <button
                    className="flex items-center gap-2"
                    onClick={() => {
                        navigate("/settings");
                    }}
                    >
                    <ChevronLeftIcon className="h-5 w-5 inline-block" />
                    Data Setup Settings /
                    </button>
                    <span className="cursor-pointer">
                    {" " + "Alerts"}
                    </span>
                </div>
            </div>
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            transaction="Alert"
            transaction_type="alert"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={invoiceItems}
            options={options}
            orders={alerts}
            setOrders={setAlerts}
            is_checkbox_req={false}
            onClickItemFn={(id) => navigate(`/view-alert/${id}`)}
            list={true}
            onclkFn={() => {
              navigate(`/add-alert`);
            }}
            permissionFn={permissionFn}
            module={"invoice"}
            path="alert"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={alertDeleteAction}
            label="Alert"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "alert_name",
              from: "",
              to: "",
              inputValue: "",
              status: "",
              channel_values: [],
            }}
            summaryArray={summaryArray}
            showFilterArrows={false}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default AlertTable;
const heading = [
  {
    label: "ALERT NAME",
    value: "alert_name",
    display: true,
    column: true,
  },
  {
    label: "CONDITION TYPE",
    value: "condition_type",
    display: true,
    column: true,
  },
  {
    label: "FREQUENCY",
    value: "frequency",
    display: true,
    column: false,
  },
  {
    label: "CHANNELS",
    value: "channels",
    display: false,
    column: true,
  },
  {
    label: "LAST RUN",
    value: "last_run_date",
    display: false,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "STATUS",
    value: "status",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "CREATED BY",
    value: "created_by",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "CREATED ON",
    value: "created_date",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "UPDATED BY",
    value: "updated_by",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: "UPDATED ON",
    value: "updated_date",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  {
    label: <span>ACTIONS</span>,
    value: "act",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
];

const options = [
  { value: "purchase_return", label: "Purchase Return" },
  { value: "purchase_invoice", label: "Purchase Invoice" },
];
